window['ThemeSection_header'] = (count) => {
  const dropdownCount = parseInt(count, 10);

  return {
    activeMenu: null,
    closeTimer: null,
    suppressNextTriggerFocus: false,
    searchOpen: false,
    headerIsSticky: false,
    scrollY: 0,
    navWrapped: false,
    headerHeight: 0,
    get isStuck() {
      return this.headerIsSticky && this.scrollY > this.headerHeight * 2;
    },
    get menuIsActive() {
      return this.activeMenu !== null;
    },
    mounted() {
      initTeleport(this.$root);

      Alpine.store('modals').register('nav', 'leftDrawer');

      document.addEventListener('keyup', (event) => {
        if (event.key !== 'Escape') return;

        if (this.searchOpen === false && this.menuIsActive) {
          this.closeMenu(true);
        } else if (this.searchOpen) {
          if (!document.getElementById('predictiveSearchResults')) {
            document.body.dispatchEvent(
              new CustomEvent('shapes:search:closebutton')
            );
          }
        }
      });

      document.addEventListener('pointerdown', (event) => {
        if (
          this.menuIsActive &&
          !event.target.closest('[data-header-dropdown]') &&
          !event.target.closest('[data-menu-trigger]')
        ) {
          this.closeMenu(false);
        }
      });

      document.body.addEventListener('shapes:search:closebutton', () => {
        this.searchOpen = false;

        this.$nextTick(() => {
          const searchToggleEl = this.$root.querySelector('[data-open-search]');

          if (searchToggleEl) {
            setTimeout(() => {
              searchToggleEl.focus();
            }, 300);
          }
        });
      });

      if (
        this.$root.hasAttribute('data-sticky-header') &&
        this.$root.hasAttribute(
          'data-transparent-when-overlay-enabled-and-stuck'
        )
      ) {
        this.setUpStickyDetection();
      }

      this.headerResizeFunctions();
      this._debouncedHeaderFunctions = debounce(
        this.headerResizeFunctions.bind(this),
        300
      );

      window.addEventListener('resize', this._debouncedHeaderFunctions);
      document.addEventListener('shopify:section:load', (event) => {
        if (!event.target.querySelector('.site-header')) return;
        this.headerResizeFunctions();
      });
    },
    headerResizeFunctions() {
      this.calculateHeaderHeight();
      this.calculateNavWrap();

      if (window.matchMedia('(max-width: 989px)').matches) {
        this.closeMenu(false);
      }
    },
    setUpStickyDetection() {
      const headerContainerEl = this.$root.closest('.shopify-section');

      const sentinelEl = document.createElement('div');
      sentinelEl.setAttribute('id', 'HeaderSentinel');

      headerContainerEl.parentNode.insertBefore(sentinelEl, headerContainerEl);

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.headerIsSticky = entry.intersectionRatio < 1;
          });
        },
        {
          rootMargin: '-1px 0px 0px 0px',
          threshold: [1],
        }
      );

      observer.observe(sentinelEl);

      let timer = null;

      const checkScrollPosition = () => {
        this.scrollY = window.scrollY;
        if (timer !== null) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          this.scrollY = window.scrollY;
        }, 150);
      };

      const _throttledScrollHandler = throttle(checkScrollPosition, 150);
      document.addEventListener('scroll', _throttledScrollHandler);

      this.scrollY = window.scrollY;
    },
    calculateNavWrap() {
      const wrappedItems = [];
      let prevItem = {};
      let currItem = {};
      if (this.$refs.navigation !== undefined) {
        const items = this.$refs.navigation.children;
        for (let i = 0; i < items.length; i++) {
          currItem = items[i].getBoundingClientRect();
          if (prevItem && prevItem.top < currItem.top) {
            wrappedItems.push(items[i]);
          }
          prevItem = currItem;
        }
        this.navWrapped = wrappedItems.length > 0;
      }
    },
    calculateHeaderHeight() {
      this.headerHeight =
        document.getElementById('headerBorderWrap').clientHeight;
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.headerHeight}px`
      );
    },
    cancelClose() {
      if (this.closeTimer !== null) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
    },
    openMenu(index) {
      if (
        index < 0 ||
        index >= dropdownCount ||
        window.matchMedia('(max-width: 989px)').matches
      ) {
        return;
      }

      this.cancelClose();
      this.searchOpen = false;
      this.activeMenu = index;
    },
    scheduleOpen(index) {
      this.cancelClose();
      this.openMenu(index);
    },
    handleTriggerFocus(index) {
      if (this.suppressNextTriggerFocus) {
        this.suppressNextTriggerFocus = false;
        return;
      }
      this.openMenu(index);
    },
    scheduleClose(index) {
      this.cancelClose();
      this.closeTimer = setTimeout(() => {
        if (this.activeMenu === index) {
          this.activeMenu = null;
        }
        this.closeTimer = null;
      }, 220);
    },
    closeMenu(returnFocus = false) {
      const closingMenu = this.activeMenu;
      this.cancelClose();
      this.activeMenu = null;

      if (returnFocus && closingMenu !== null) {
        this.$nextTick(() => {
          const trigger = this.$root.querySelector(
            `[data-menu-trigger][data-menu-index="${closingMenu}"]`
          );
          if (trigger && document.activeElement !== trigger) {
            this.suppressNextTriggerFocus = true;
            trigger.focus();
            setTimeout(() => {
              this.suppressNextTriggerFocus = false;
            }, 0);
          }
        });
      }
    },
    openMenuAndFocus(index) {
      this.openMenu(index);
      this.$nextTick(() => {
        const panel = this.$root.querySelector(
          `[data-header-dropdown][data-menu-index="${index}"]`
        );
        const firstLink = panel && panel.querySelector('[data-menu-first-link]');
        if (firstLink) firstLink.focus();
      });
    },
    focusOut(event, index) {
      if (!event.currentTarget.contains(event.relatedTarget)) {
        this.scheduleClose(index);
      }
    },
    searchFocusOut() {
      this.$nextTick(() => {
        if (!this.$refs.searchFieldComponent.contains(document.activeElement))
          this.searchOpen = false;
      });
    },
    closeSearch() {
      this.searchOpen = false;
      this.$refs.search.focus();
    },
    openSearch() {
      this.closeMenu(false);
      this.searchOpen = true;
      const input = document.querySelector('.header-search-input');
      setTimeout(() => {
        input.focus();
      }, 100);
    },
  };
};
